import { createSelector } from 'reselect';
import { getEntities, getResults } from 'reducers';
import Immutable from 'immutable';
import { denormalize } from 'normalizr';
import { term } from 'schemas';

export const getTerms = createSelector(
  state => getResults(state).get('terms', Immutable.List()),
  state => getEntities(state),
  (result, entities) =>
    denormalize(
      result,
      term.schema,
      entities,
    ),
);
